'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _templateObject = _taggedTemplateLiteral(['\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n'], ['\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  font-size: inherit !important;\n  display: inline-block;\n  ', ';\n'], ['\n  font-size: inherit !important;\n  display: inline-block;\n  ', ';\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n          animation: ', ' 0.75s linear infinite;\n        '], ['\n          animation: ', ' 0.75s linear infinite;\n        ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

require('./assets/iconfont.css');

var _icons = require('./icons');

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Assets
// Icons
// Helpers


var rotate360 = (0, _styledComponents.keyframes)(_templateObject);

var Icon = function Icon(_ref) {
  var icon = _ref.icon,
      className = _ref.className,
      spin = _ref.spin,
      props = _objectWithoutProperties(_ref, ['icon', 'className', 'spin']);

  return _react2.default.createElement('i', _extends({
    className: 'icon anticon icon-' + icon + ' ' + className
  }, props));
};

Icon.propTypes = {
  icon: _propTypes2.default.oneOf(_icons2.default).isRequired,
  className: _propTypes2.default.string,
  spin: _propTypes2.default.bool
};
exports.default = (0, _styledComponents2.default)(Icon)(_templateObject2, function (_ref2) {
  var spin = _ref2.spin;
  return spin ? (0, _styledComponents.css)(_templateObject3, rotate360) : '';
});